export default __webpack_public_path__ + "static/media/SuraSans-Regular.690f0079.otf";